// Generated by tools/extract_mb2ws_stage_names.mjs
// Source: MB2WS-NTSC-ROM/files/stgname/usa.str

export const MB2WS_STAGE_NAMES: Readonly<Record<number, string>> = {
  1: "PLAYGROUND",
  2: "GAP",
  3: "SLANTY",
  4: "HANDSHAKE",
  5: "FIELD",
  6: "PARALLAX",
  7: "CLING",
  8: "STEADY",
  9: "GENTLE PATH",
  10: "STARGAZING",
  11: "BROKEN LADDER",
  12: "KEYHOLES",
  13: "SLICED FLOORS",
  14: "BRUSHSTROKE",
  15: "TOTALITARIANISM",
  16: "MOUSEHOLES",
  17: "SIDESTEP",
  18: "UPJUMP",
  19: "INVERTED TORI",
  20: "COUNTERBALANCE",
  21: "PLAYGROUND",
  22: "CAREFUL CORNERS",
  23: "TILT PATH",
  24: "WALTZ",
  25: "INTERWOVEN",
  26: "HOURGLASSES",
  27: "RETROREFLECTION",
  28: "TIDE",
  29: "BROKEN IN",
  30: "VAULT",
  31: "BUMP JUMP",
  32: "LUCKY",
  33: "EROSION",
  34: "LIFTS",
  35: "HEAVENSCRAPER",
  36: "WALK THE DOG",
  37: "TRAIN OF THOUGHT",
  38: "SWING BARS",
  39: "MARBLE PARTY",
  40: "BREAKFAST",
  41: "ELATED RINGS",
  42: "BENT CLIP",
  43: "JUMPY OPTION",
  44: "POOL NOODLE",
  45: "ELEVATORS",
  46: "J-DROP",
  47: "QUADRATIC",
  48: "CRACKER",
  49: "FOLDED",
  50: "NET",
  51: "CONCENTRIC",
  52: "BALLSY BOUNCE",
  53: "DIPPED PATH",
  54: "BUBBLES",
  55: "CUTTING EDGE",
  56: "TRAPDOOR",
  57: "TRAJECTORY",
  58: "CIRCUMFERENCE",
  59: "PUNCHED",
  60: "STUNT RAMP",
  61: "SPEEDBUMP",
  62: "CAREFUL CROSSING",
  63: "PEEL",
  64: "FUNCTION",
  65: "BRIDGEMAKER",
  66: "RISK & REWARD",
  67: "PYRAMID",
  68: "FRICTIONLESS",
  69: "TRAMPOLINE RUN",
  70: "POP QUIZ",
  71: "CENTRIPETAL",
  72: "FACES",
  73: "CONVERSION",
  74: "ARMS",
  75: "VELOCITY",
  76: "MEETING",
  77: "BACKWASH",
  78: "TUNNELS",
  79: "TRANSFER",
  80: "FREESTYLER",
  81: "SWAP",
  82: "SHATTERED",
  83: "BANANA CANE",
  84: "SHAKEN",
  85: "A-MAZE-ING",
  86: "SLOW & STEADY",
  87: "FLIPSIDE",
  88: "DARK WORLD",
  89: "SWING HAMMER",
  90: "SLIDE",
  91: "ROOFTOP",
  93: "LINKED",
  94: "DIVIDED",
  95: "BEACHSIDE",
  96: "TRIPLEDECKER",
  97: "SLINKY",
  98: "WIREY HILLS",
  99: "TRAFFIC",
  100: "HOME RUN",
  101: "PLAYGROUND",
  102: "GAP",
  121: "SLANTY",
  122: "HANDSHAKE",
  123: "GENTLE PATH",
  131: "KEYHOLES",
  132: "BRUSHSTROKE",
  133: "AMPLITUDE",
  134: "DOUBLECROSS",
  135: "CLING",
  136: "J-DROP",
  137: "INVERTED TORI",
  150: "WALK THE DOG",
  161: "TRAIN OF THOUGHT",
  162: "BROKEN LADDER",
  163: "UPJUMP",
  164: "MOUSEHOLES",
  165: "CRACKER",
  166: "POLAR WALL",
  167: "COUNTERBALANCE",
  168: "RETROREFLECTION",
  169: "HOURGLASSES",
  170: "CHUCKERS",
  171: "INTERWOVEN",
  172: "DIPPED PATH",
  173: "BOOKWORM",
  174: "TRAJECTORY",
  175: "PEEL",
  176: "QUADRATIC",
  177: "PEEK-A-BOO",
  178: "FRICTIONLESS",
  181: "NOUGHTS & CROSSES",
  182: "BEHOLDEN",
  183: "PATTERN",
  185: "TRADEOFF",
  186: "COPASETIC",
  187: "DOUBLE CRANK",
  188: "FIGHTER",
  189: "MESH",
  191: "ASSEMBLY LINE",
  192: "TRAMPOLINE RUN",
  193: "JUMPY OPTION",
  194: "EROSION",
  195: "CHAIN",
  196: "BEACHSIDE",
  201: "CUT SLOPES",
  202: "BLIND BOUNCE",
  203: "GALAXY",
  204: "ELSA'S CASTLE FROM FROZEN",
  205: "RING BUMP",
  206: "WINDMILLS",
  207: "FORGOTTEN PATH",
  208: "PERCUSSIVE INSTRUMENTS",
  209: "TRAY",
  210: "MULTIPLY",
  211: "FUNNEL",
  212: "DECONSTRUCTION",
  213: "STEERING WHEEL",
  214: "TABS",
  215: "WINDY WALK",
  216: "MOBIUS DONUT",
  217: "BROKEN PINS",
  218: "DUMBBELL",
  219: "SAWTEETH",
  220: "FRANTIC",
  221: "UNBOXING",
  222: "ICE CREAM",
  223: "TILT WIRE",
  224: "TORI",
  225: "GAME OF LIFE",
  226: "MOMENTUM",
  227: "WAVY PATH",
  228: "SYNCHRONIZATION",
  229: "TOTALITARIANISM",
  230: "4-D",
  231: "SHIFT",
  232: "FAITH",
  233: "ORDER",
  234: "LIFE",
  235: "FOCUS",
  236: "TWIST",
  237: "JOURNEY",
  238: "PULL",
  239: "FLOW",
  240: "RIFT",
  241: "FRAMES",
  242: "TOWERS",
  243: "COIL",
  244: "SWORD",
  245: "TEMPLES",
  246: "HOOK",
  247: "UNDERNEATH",
  248: "WIGGLY",
  249: "SWISS",
  250: "OH, SCREW THIS!",
  251: "REVERSE BUILDING",
  252: "SNAKE",
  253: "SYNCED",
  254: "BUBBLES",
  255: "CENTRIPETAL",
  256: "SHAKEN",
  257: "ELATED RINGS",
  258: "MARBLE PARTY",
  259: "PEDALING",
  260: "FUNNEL JUMP",
  261: "PENDULUM PLATFORMS",
  262: "ARCHWAY",
  263: "BREEZE",
  264: "VOXEL FIELD",
  265: "CUT SLOPES",
  266: "4-D",
  267: "GALAXY",
  268: "RING TRANSFER",
  269: "PERCUSSIVE INSTRUMENTS",
  270: "RING BUMP",
  271: "TRAY",
  272: "CONVERSION",
  273: "FREESTYLER",
  274: "SKILIFTS",
  275: "BALANCE",
  276: "LINKED",
  277: "TASK",
  278: "TRIALS",
  279: "BACK & FORTH",
  280: "EARTHQUAKE",
  281: "DREAM CATCHER",
  282: "VELOCITY",
  283: "PUNCHED",
  284: "FUNNEL",
  285: "FORGOTTEN PATH",
  286: "DECONSTRUCTION",
  287: "CONNECTIONS",
  288: "FLIPSIDE",
  289: "MENGER",
  290: "BANANA HUNTING",
  291: "STEERING WHEEL",
  292: "WINDY WALK",
  293: "SPIRAL TOWER",
  294: "BULLRIDE",
  295: "DUMBBELL",
  296: "FRANTIC",
  297: "RECORDER",
  298: "SINGLE SPIRAL",
  299: "WASP HIVE",
  300: "FIGHTERS",
  301: "FOOTWORMS",
  302: "DESPOTISM",
  303: "DOWN-AND-AROUNDHILL",
  304: "ERRATIC MAZE",
  305: "LEADED PIPE",
  306: "CORKSCREW BRIDGE",
  307: "13 BRACELETS",
  308: "CONTROL",
  309: "PATIENCE",
  310: "SURGICAL",
  311: "PRECISION",
  312: "WRUNG",
  313: "BRACKETS",
  314: "WELL-ROUNDED",
  315: "EXECUTION",
  316: "SHRIEK",
  317: "CULMINATION",
  318: "CONICAL SLIDER",
  319: "CONSTRUCTION",
  320: "TRAIN WORM",
  321: "BEACHSIDE",
  322: "SWING BRIDGES",
  323: "CYLINDERS",
  324: "PASSAGE",
  325: "NOTCH",
  326: "INTERMITTENT",
  327: "LONG TORUS",
  328: "SPASMODIC",
  329: "DOUBLE TWIN",
  330: "CLOCK FACE",
  331: "VARIABLE WIDTH",
  332: "STRIKER",
  333: "OOPARTS",
  334: "PLANETS",
  335: "SLICED CHEESE",
  336: "8 SEESAWS",
  337: "SYNCHRONIZED",
  338: "HELIX",
  339: "DIZZY SYSTEM",
  340: "NINTENDO",
  341: "DARK WORLD",
  342: "UNBOXING",
  343: "SURGICAL",
  344: "LUST",
  345: "WRUNG",
  346: "BRACKETS",
  347: "WELL ROUNDED",
  348: "EXECUTION",
  349: "SHRIEK",
  350: "CULMINATION",
  361: "TAFFY",
  362: "BOOKWORM",
  363: "PEDALING",
  364: "CHAIN",
  365: "SNAKE",
  366: "POLAR WALL",
  367: "DREAM CATCHER",
  368: "BENT CARDS",
  369: "EYE TO EYE",
  370: "INTERNAL",
  375: "DOUBLECROSS",
  381: "BIFROST",
  384: "ARCHWAY",
  389: "BOOMERANG",
  396: "WWIAFTB",
} as const;

export function getMb2wsStageName(stageId: number): string | null {
  if (!Number.isFinite(stageId)) {
    return null;
  }
  const key = Math.trunc(stageId);
  const name = MB2WS_STAGE_NAMES[key];
  return typeof name === 'string' ? name : null;
}
